// the following constants are deprecated (need to figure out how to handle this)
// use MDB_TYPES, SELECTION_TYPES, PREFIXES, and SYSTEMS instead
export const ANSWER = "answer"
export const ASSESS = "assessment"
export const ASSESSO = "assessment-option"
export const ASSESS_OPTION = "assessment-option"
export const AWO = "assessment-with-options"
export const CB = "checkbox"
export const CL_HEADING = "checklist-heading"
export const CL_PROMPT = "checklist-prompt"
export const CRIT_FAIL = "critical-criteria"
export const DECISION = "decision"
export const DECISION_OPTION = "decision-option"
export const DIST_PROMPT = "distinguishing-prompt"
export const HEADING = "heading" //not a leaf node, simply a step which has child steps
export const INTERV = "intervention" // an action performed on the patient
export const INTV_FORM = "intervention-form"
export const NESTED_CHECKLIST = "nested-checklist"
export const NONE = "none"
export const ONE = "one"
export const OOM = "one-or-more"
const OOM_AND = "one-or-more-logical-and"
const OOM_OR = "one-or-more-logical-or"
export const OPTION = "option"
export const PHASE = "phase"
export const PROMPT = "prompt"
export const PROMPT_SET = "prompt-set"
export const REQUIRED = "required-action"   // an action the EMT performs, but not on the patient
// keeping as I had a typo. need to deprecate somehow
export const REQURED = REQUIRED
export const SUB_PHASE = "sub-phase"

export const MDB_TYPES = Object.freeze({
    PHASE: PHASE,
    SUB_PHASE: SUB_PHASE,
    ASSESS: ASSESS,
    AWO: AWO,
    ASSESS_OPTION: ASSESS_OPTION,
    ASSESSO: ASSESS_OPTION,
    CL_HEADING: CL_HEADING,
    CL_PROMPT: CL_PROMPT,
    DECISION: DECISION,
    DECISION_OPTION: DECISION_OPTION,
    DIST_PROMPT: DIST_PROMPT,
    NESTED_CHECKLIST: NESTED_CHECKLIST,
    REQUIRED: REQUIRED,
    REQURED: REQUIRED,
    INTERV: INTERV,
    PROMPT_SET: PROMPT_SET,
    PROMPT: PROMPT,
    ANSWER: ANSWER,
})
export const SELECTION_TYPES = Object.freeze({
    ONE: ONE,
    OOM: OOM,
    OOM_AND: OOM_AND,
    OOM_OR: OOM_OR,
    NONE: NONE
})
export const SELECTION_TYPE_LABELS = Object.freeze({
    "one": "One",
    "one-or-more": "One or more",
    "one-or-more-logical-and": "One or more (logical AND)",
    "one-or-more-logical-or": "One or more (logical OR)",
    "none": "None"
})
export const PREFIXES = Object.freeze({
    PHASE: "",
    SUB_PHASE: "",
    ANSWER: "answer-",
    ASSESS: "assess-",
    AWO: "assessment-with-options-",
    ASSESS_OPTION: "assess-option-",
    CL_PROMPT: "cl-prompt-",
    DECISION: "decision-",
    DECISION_OPTION: "decision-option-",
    INTERV: "intv-",
    PROMPT_SET: "prompt-set-",
    PROMPT: "prompt-",
    REQUIRED: "required-action-",
})

export const SYSTEMS = Object.freeze({
    AW: "airway",
    BR: "breathing",
    BL: "bleeding",
    SH: "shock",
    OTH: "other",
})
export const SYSTEM_LABELS = Object.freeze({
    AW: "Airway",
    BR: "Breathing",
    BL: "Bleeding",
    SH: "Shock",
    OTH: "Other",
})

export const CHECKLIST_STEP_TYPES = [ASSESS, AWO, DECISION, REQUIRED]
export const OPTION_TYPES = [ASSESS_OPTION, DECISION_OPTION]
export const ANALYSIS_TYPES = [ASSESS, AWO, DECISION, REQUIRED, INTERV, PHASE, SUB_PHASE]

export const PROTOCOL_RELATIONSHIPS = Object.freeze({
    NONE: "",
    MIN: "minimal",
    OPT: "optional",
    REQ: "required",
    CONTRA: "contraindicated",
    NOTIND: "not indicated",
    UNN: "unnecessary",
    IR: "irrelevant",
    ALT: "alternative"
})